export default __webpack_public_path__ + "static/media/4 kirushanka.22e1a0a5.jpg";